/* tslint:disable */
import gql from "graphql-tag";

export const getAccount = /* GraphQL */ gql`
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      createdAt
      updatedAt
      ownerId  
      name
      address
      city
      state
      postalCode
      accountType
      accountStatus
      accountSize  
      customerId  
      classes(limit: 1000) {
          items {
              id
              createdAt
              updatedAt
              courseId
              accountId
              ownerId
              userId
              termBegin
              termEnd
              seatsPurchased
              seatsFilled
              couponCode
              assignmentSchedule
          }
          nextToken
      }
    }
  }
`;
export const listAccounts = /* GraphQL */ gql`
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        ownerId  
        name
        address
        city
        state
        postalCode
        accountType
        accountStatus
        accountSize  
        customerId
      }
      nextToken
    }
  }
`;

export const getAccountUsers = /* GraphQL */ gql`
    query GetAccount($id: ID!, $filter: ModelUserFilterInput) {
        getAccount(id: $id) {
            id
            users(filter: $filter, limit: 1000) {
                items {
                    id
                    createdAt
                    updatedAt
                    invitedAt
                    accountId
                    firstName
                    lastName
                    email
                    phone
                    jobTitle
                    userStatus
                    role
                    customerId
                }
                nextToken
            }
        }
    }
`;

export const getClass = /* GraphQL */ gql`
  query GetClass($id: ID!) {
    getClass(id: $id) {
      id
      createdAt
      updatedAt
      courseId
      course {
        id
        createdAt
        updatedAt
        title
        description
        coverUrl
        details
        publishDate
        sunsetDate
        lessonCount
        creditHours
        isFree
        lessons
        classes {
          nextToken
        }
      }
      accountId
      ownerId
      userId
      termBegin
      termEnd
      seatsPurchased
      seatsFilled
      couponCode
      assignmentSchedule  
      registrations(limit: 1000) {
        items {
          id
          createdAt
          updatedAt
          accountId
          classId
          userId
          classStatus
          classProgress
          lessonNumber
          lessonId
          lessonStatus
          videoProgress
          answers
          score
          startedAt
          endsAt  
          completedAt
          lessonsAssigned
          nextAssignmentAt
        }
        nextToken
      }
    }
  }
`;

export const listUsers = /* GraphQL */ gql`
    query ListUsers(
        $filter: ModelUserFilterInput
        $limit: Int
        $nextToken: String
    ) {
        listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                createdAt
                updatedAt
                accountId
                firstName
                lastName
                email
                phone
                jobTitle
                userStatus
                invitedAt
                role
                customerId
            }
            nextToken
        }
    }
`;

export const getUser = /* GraphQL */ gql`
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      createdAt
      updatedAt
      invitedAt  
      accountId
      firstName
      lastName
      email
      phone
      jobTitle
      userStatus
      role
      customerId
    }
  }
`;

export const getPublicUser = /* GraphQL */ gql`
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            accountId
            email
            userStatus
            role
        }
    }
`;

export const loadUser = /* GraphQL */ gql`
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            createdAt
            updatedAt
            invitedAt
            accountId
            firstName
            lastName
            email
            phone
            jobTitle
            userStatus
            role
            accountId
            account {
                id
                createdAt
                updatedAt
                ownerId
                name
                address
                city
                state
                postalCode
                accountType
                accountStatus
                accountSize
                customerId
                classes(limit: 1000) {
                    items {
                        id
                        createdAt
                        updatedAt
                        courseId
                        accountId
                        ownerId
                        userId
                        termBegin
                        termEnd
                        seatsPurchased
                        seatsFilled
                        couponCode
                        assignmentSchedule
                    }
                    nextToken
                }
            }
            registrations(limit: 1000) {
                items {
                    id
                    createdAt
                    updatedAt
                    accountId
                    classId
                    userId
                    classStatus
                    classProgress
                    lessonNumber
                    lessonId
                    lessonStatus
                    videoProgress
                    answers
                    score
                    startedAt
                    endsAt
                    completedAt
                    lessonsAssigned
                    nextAssignmentAt
                }
                nextToken
            }
            customerId
        }
    }
`;

// Course

export const getCourse = /* GraphQL */ gql`
  query GetCourse($id: ID!) {
    getCourse(id: $id) {
      id
      createdAt
      updatedAt
      title
      description
      coverUrl
      details
      publishDate
      sunsetDate
      lessonCount
      creditHours
      isFree
      lessons
    }
  }
`;
export const listCourses = /* GraphQL */ gql`
  query ListCourses(
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
          id
          createdAt
          updatedAt
          title
          description
          coverUrl
          details
          publishDate
          sunsetDate
          lessonCount
          creditHours
          isFree
      }
      nextToken
    }
  }
`;

// Registration

export const getRegistration = /* GraphQL */ gql`
  query GetRegistration($id: ID!) {
    getRegistration(id: $id) {
      id
      createdAt
      updatedAt
      accountId
      classId
      class {
        id
        createdAt
        updatedAt
        courseId
        accountId
        ownerId
        userId
        termBegin
        termEnd
        seatsPurchased
        seatsFilled
        couponCode
        assignmentSchedule  
      }
      userId
      classStatus
      classProgress
      lessonNumber
      lessonId
      lessonStatus  
      videoProgress
      answers
      score
      startedAt
      endsAt
      completedAt
      lessonsAssigned
      nextAssignmentAt
        
    }
  }
`;

export const listRegistrations = /* GraphQL */ gql`
    query ListRegistrations(
        $filter: ModelRegistrationFilterInput
        $limit: Int
        $nextToken: String
    ) {
        listRegistrations(filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                createdAt
                updatedAt
                accountId
                classId
                userId
                classStatus
                classProgress
                lessonNumber
                lessonId
                lessonStatus
                videoProgress
                answers
                score
                startedAt
                endsAt
                completedAt
                lessonsAssigned
                nextAssignmentAt
            }
            nextToken
        }
    }
`;

// Activity
export const listAccountActivity = /* GraphQL */ gql`
  query GetAccount(
      $id: ID!
      $filter: ModelActivityFilterInput
      $limit: Int
      $sortDirection: ModelSortDirection
      $nextToken: String
  ) {
    getAccount(id: $id) {
      id
      activity(filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
        items {
          id
          createdAt
          updatedAt
          accountId
          userId
          activityDate
          activityType
          objectId
          values
        }
        nextToken
      }
    }
  }
`;

export const listActivitys = /* GraphQL */ gql`
  query ListActivitys(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        accountId
        userId
        activityDate
        activityType
        objectId
        values
      }
      nextToken
    }
  }
`;
export const listActivityByDate = /* GraphQL */ gql`
  query ListActivityByDate(
    $activityDate: AWSDate
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityByDate(
      activityDate: $activityDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        accountId
        userId
        activityDate
        activityType
        objectId
        values
      }
      nextToken
    }
  }
`;
export const listActivityByAccount = /* GraphQL */ gql`
    query ListActivityByAccount(
        $accountId: ID
        $activityDate: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelActivityFilterInput
        $limit: Int
        $nextToken: String
    ) {
        listActivityByAccount(
            accountId: $accountId
            activityDate: $activityDate
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                createdAt
                updatedAt
                accountId
                userId
                activityDate
                activityType
                objectId
                values
            }
            nextToken
        }
    }
`;